module.exports = __webpack_public_path__ + "img/ybpay-charge.72e81ed2.svg";